var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlertIcon = function SvgAlertIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 15.3896C20.4158 16.5005 19.6113 17.8891 18.3313 17.8891H1.66855C0.386017 17.8891 -0.414747 16.4983 0.224906 15.3896L8.55636 0.944141C9.19758 -0.167283 10.8036 -0.165269 11.4437 0.944141L19.7749 15.3896ZM10 12.403C9.11789 12.403 8.40279 13.1181 8.40279 14.0002C8.40279 14.8823 9.11789 15.5974 10 15.5974C10.8821 15.5974 11.5972 14.8823 11.5972 14.0002C11.5972 13.1181 10.8821 12.403 10 12.403ZM8.48358 6.66181L8.74115 11.384C8.7532 11.605 8.93591 11.778 9.15719 11.778H10.8428C11.0641 11.778 11.2468 11.605 11.2589 11.384L11.5164 6.66181C11.5295 6.42313 11.3394 6.22244 11.1004 6.22244H8.89959C8.66056 6.22244 8.47056 6.42313 8.48358 6.66181Z",
    fill: "#FF9536"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-icon.bdaf3a8f.svg";
export { ForwardRef as ReactComponent };